import reduceReducers from "reduce-reducers";
import { deleteById, reduceById } from "redux-store/reducers";

import {
  CREATE_ALERT_V3_SUCCESS,
  DELETE_ALERT_V3_SUCCESS,
  EDIT_ALERT_V3_SUCCESS,
  LOAD_ALERTS_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
} from "./actions";
import { getApiReducer } from "/redux-store/api-sagas";

const apiAlertReducer = getApiReducer(
  LOAD_ALERTS_V3_SUCCESS,
  LOAD_ALERTS_V3_FAILURE,
);

function extraReducer(state = {}, action) {
  const { type, payload } = action;
  const { data: alert } = payload || {};

  switch (type) {
    case CREATE_ALERT_V3_SUCCESS:
    case EDIT_ALERT_V3_SUCCESS:
      return {
        ...state,
        byId: reduceById(state.byId, [alert]),
      };
    case DELETE_ALERT_V3_SUCCESS:
      return {
        ...state,
        byId: deleteById(state.byId, [{ id: alert.id }]),
      };
    default:
      return state;
  }
}

const alertV3Reducer = reduceReducers(apiAlertReducer, extraReducer);

export { alertV3Reducer, extraReducer };
